module.exports = __webpack_public_path__ + "img/works_mixi_xflag_2.7e810f64.png";